import { createSlice } from "@reduxjs/toolkit";
import { getMeDispatch } from "../dispatch/profile/get-me";
import { logoutDispatch } from "../dispatch/profile/logout";
import { RootState } from "../store";
import { ProfileState } from "../type/profile-state";

const initialState: ProfileState = {
  profile: undefined,
  isLoggedIn: false,
  status: "idle",
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    getMeAction: getMeDispatch,
    logoutAction: logoutDispatch,
  },
});

export const { getMeAction, logoutAction } = profileSlice.actions;

export const profileState = (state: RootState) => state.profile;

export default profileSlice.reducer;
